export enum TeamMemberType {
	Internal = "Internal",
	External = "External",
}
